import { Pagination } from "antd";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type Props = {
  totalNumber: number;
  page: number;
  pageSize: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
};

const DashPagination = (props: Props) => {
  const { page, setPage, totalNumber, pageSize, setPageSize } = props;

  const location = useLocation();
  const navigate = useNavigate();

  // Read from URL (1-based in URL → convert to 0-based internally)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page") || "1", 10); // default to 1 in URL
    const sizeParam = parseInt(params.get("pageSize") || "10", 10);

    setPage(isNaN(pageParam) || pageParam < 1 ? 0 : pageParam - 1); // store as 0-based
    setPageSize(isNaN(sizeParam) ? 10 : sizeParam);
  }, []);

  // Write to URL (convert 0-based → 1-based in URL)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", String(page + 1)); // URL is 1-based
    params.set("pageSize", String(pageSize));

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  }, [page, pageSize]);

  return (
    <div className="flex justify-end">
      <Pagination
        current={page + 1}
        onChange={(page) => setPage(page - 1)}
        total={totalNumber}
        pageSize={pageSize}
        onShowSizeChange={(_, size) => {
          setPageSize(size);
          setPage(0);
        }}
        showSizeChanger
        showQuickJumper
        showTotal={(total) => (
          <span className="text-sm bg-white p-2 font-bold rounded-lg">
            Total {total} items
          </span>
        )}
      />
    </div>
  );
};

export default DashPagination;
